import React from 'react';

import { Typography } from '@natu/ui/Typography';
import { cn } from '@natu/utils/cn';

import {
  type BlokItem,
  DynamicRender,
  type SBProps,
  type Spacing,
  resolveStoryblokStyles,
  sbEditable,
} from '../../../../utils';

interface SBCarouselWithCountersProps {
  carousel?: BlokItem[];
  content?: BlokItem[];
  titleTag?: 'h1' | 'h2' | 'h3';
  title?: string;
  description?: string;
  mtMobile?: Spacing;
  mtTablet?: Spacing;
  mtDesktop?: Spacing;
  mbMobile?: Spacing;
  mbTablet?: Spacing;
  mbDesktop?: Spacing;
}

export const SBCarouselWithCounters = ({ blok }: SBProps<SBCarouselWithCountersProps>) => {
  const {
    carousel,
    content,
    titleTag,
    title,
    description,
    mbDesktop,
    mbMobile,
    mbTablet,
    mtDesktop,
    mtMobile,
    mtTablet,
  } = blok;

  const className = resolveStoryblokStyles({
    mt: mtMobile,
    mtTablet,
    mtDesktop,
    mb: mbMobile,
    mbTablet,
    mbDesktop,
    className: 'max-w-[1440px] mx-auto @container',
  });

  return (
    <section className={className} {...sbEditable(blok)}>
      <div className="mx-auto mb-10 flex flex-col gap-4 px-4 lg:mb-16 lg:max-w-4xl lg:items-center lg:gap-5 lg:px-0">
        <Typography
          component={titleTag || 'h2'}
          className="font-semibold lg:text-center"
          variant={['display-sm', 'display-sm', 'display-lg']}
        >
          {title}
        </Typography>
        <Typography
          className="text-gray-600 lg:text-center"
          variant={['text-lg', 'text-lg', 'text-xl']}
        >
          {description}
        </Typography>
      </div>
      <div
        className={cn(
          'relative mx-4 mb-7 grid max-w-7xl grid-cols-2 gap-x-6 gap-y-8 rounded-3xl pt-10',
          '@5xl:gap-x-8 @5xl:mx-auto @5xl:px-16 @5xl:pt-16 @5xl:grid-cols-4 @5xl:mb-[77px]',
          'after:absolute after:left-0 after:right-0 after:top-0 after:z-[-1] after:h-[calc(400px+6vw)] after:rounded-3xl after:bg-[#F2F8F9] after:content-[""]',
        )}
      >
        <DynamicRender data={content} />
      </div>
      <DynamicRender data={carousel} />
    </section>
  );
};
